import { useState } from 'react';
import { logEntryApi } from '../api/logbookApi';
import './NewEntryModal.css';

const CATEGORY_CONFIG = {
  other:        { label: 'Egyéb / parkoló', icon: 'ti-parking' },
  pickup:       { label: 'Felrakó',    icon: 'ti-package' },
  delivery:     { label: 'Lerakó',     icon: 'ti-package-export' },
  customs:      { label: 'Vámkezelés', icon: 'ti-stamp' },
  refuel:       { label: 'Tankolás',   icon: 'ti-gas-station' },
};

function nowLocal() {
  const now = new Date();
  now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
  return now.toISOString().slice(0, 16);
}

export default function EditEntryModal({ entry, onClose, onSaved }) {
  const cfg = CATEGORY_CONFIG[entry.category] || {};

  const [arrival, setArrival] = useState(entry.arrival ? entry.arrival.slice(0, 16) : nowLocal());
  const [departure, setDeparture] = useState(entry.departure ? entry.departure.slice(0, 16) : '');
  const [diesel, setDiesel] = useState(entry.diesel || '');
  const [adblue, setAdblue] = useState(entry.adblue || '');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  // Meghatározzuk, mely mezők szerkeszthetők (csak az üresek)
  const canEditArrival = !entry.arrival;
  const canEditDeparture = !entry.departure;
  const canEditDiesel = entry.category === 'refuel' && !entry.diesel;
  const canEditAdblue = entry.category === 'refuel' && !entry.adblue;

  const handleSave = async () => {
    setError('');
    const payload = {};
    if (canEditArrival && arrival) payload.arrival = arrival;
    if (canEditDeparture && departure) payload.departure = departure;
    if (canEditDiesel && diesel) payload.diesel = diesel;
    if (canEditAdblue && adblue) payload.adblue = adblue;

    if (Object.keys(payload).length === 0) {
      setError('Nincs módosítandó adat.');
      return;
    }

    setSaving(true);
    try {
      await logEntryApi.patch(entry.id, payload);
      onSaved();
    } catch {
      setError('Nem sikerült menteni a módosítást.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-box" onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>
            <i className={`ti ${cfg.icon}`}></i> {cfg.label} – módosítás
          </h3>
          <button className="modal-close" onClick={onClose}>
            <i className="ti ti-x"></i>
          </button>
        </div>

        <div className="modal-body">
          <div className="edit-entry-city">
            <i className="ti ti-map-pin"></i>
            {entry.city}
          </div>

          {/* Érkezés */}
          <label>
            Érkezés
            {!canEditArrival && <span className="field-locked"><i className="ti ti-lock"></i> Rögzítve</span>}
          </label>
          <input
            type="datetime-local"
            className={`entry-input ${!canEditArrival ? 'input-locked' : ''}`}
            value={arrival}
            onChange={e => setArrival(e.target.value)}
            disabled={!canEditArrival}
          />

          {/* Távozás */}
          <label>
            Távozás
            {!canEditDeparture && <span className="field-locked"><i className="ti ti-lock"></i> Rögzítve</span>}
          </label>
          <input
            type="datetime-local"
            className={`entry-input ${!canEditDeparture ? 'input-locked' : ''}`}
            value={departure}
            onChange={e => setDeparture(e.target.value)}
            disabled={!canEditDeparture}
          />

          {/* Tankolás mezők */}
          {entry.category === 'refuel' && (
            <div className="entry-time-row">
              <div className="entry-time-col">
                <label>
                  Dízel (liter)
                  {!canEditDiesel && <span className="field-locked"><i className="ti ti-lock"></i> Rögzítve</span>}
                </label>
                <input
                  type="number"
                  className={`entry-input ${!canEditDiesel ? 'input-locked' : ''}`}
                  placeholder="pl. 320"
                  value={diesel}
                  onChange={e => setDiesel(e.target.value)}
                  disabled={!canEditDiesel}
                />
              </div>
              <div className="entry-time-col">
                <label>
                  AdBlue (liter)
                  {!canEditAdblue && <span className="field-locked"><i className="ti ti-lock"></i> Rögzítve</span>}
                </label>
                <input
                  type="number"
                  className={`entry-input ${!canEditAdblue ? 'input-locked' : ''}`}
                  placeholder="pl. 20"
                  value={adblue}
                  onChange={e => setAdblue(e.target.value)}
                  disabled={!canEditAdblue}
                />
              </div>
            </div>
          )}

          {error && <p className="modal-error">{error}</p>}
        </div>

        <div className="modal-footer">
          <button className="btn-secondary" onClick={onClose}>Mégse</button>
          <button className="btn-primary" onClick={handleSave} disabled={saving}>
            {saving ? 'Mentés...' : 'Módosítás mentése'}
          </button>
        </div>
      </div>
    </div>
  );
}